import Header from '../components/Header';
import Footer from '../components/Footer';

const launchpadPrograms = [
  {
    name: 'MERN Stack Development',
    description: 'Build the foundation for a successful software development career.',
    oldPrice: '₹ 35,000',
    price: '₹ 30,000',
    iconSrc: '/images/programs/launchpad/mern.png',
  },
  {
    name: 'Data Science & Machine Learning',
    description: 'Develop future-ready analytical and AI-driven problem-solving skills.',
    oldPrice: '₹ 35,000',
    price: '₹ 30,000',
    iconSrc: '/images/programs/launchpad/data-science.png',
  },
  {
    name: 'Finance',
    description: 'Accelerate your journey towards modern finance and business careers.',
    oldPrice: '₹ 35,000',
    price: '₹ 30,000',
    iconSrc: '/images/programs/launchpad/finance.png',
  },
  {
    name: 'HR & Management',
    description: 'Prepare for leadership, people management, and corporate excellence.',
    oldPrice: '₹ 35,000',
    price: '₹ 30,000',
    iconSrc: '/images/programs/launchpad/hr.png',
  },
];

const flagshipPrograms = [
  {
    name: 'AI-Powered Full Stack Program',
    description: 'An immersive technology program crafted for future software professionals.',
    oldPrice: '₹ 55,000',
    price: '₹ 50,000',
    visual: '/images/programs/fullstack-visual.png',
  },
  {
    name: 'Finance & Accounting Program',
    description: 'A comprehensive finance transformation program designed for corporate excellence.',
    oldPrice: '₹ 55,000',
    price: '₹ 50,000',
    visual: '/images/programs/growth-chart.png',
  },
];

const super51Phases = [
  {
    phase: 'PHASE 01',
    duration: '6 Months',
    title: 'Intensive CAT Preparation',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-8 w-8" aria-hidden="true">
        <rect x="10" y="12" width="28" height="26" rx="3" stroke="currentColor" strokeWidth="2.2" />
        <path d="M10 20h28M18 8v8M30 8v8" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M18 28h4M24 28h4M30 28h4M18 33h4M24 33h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    phase: 'PHASE 02',
    duration: '3 Months',
    title: 'Revision & Doubt Support',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-8 w-8" aria-hidden="true">
        <circle cx="24" cy="16" r="6" stroke="currentColor" strokeWidth="2.2" />
        <path d="M12 38c0-6.627 5.373-12 12-12s12 5.373 12 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    phase: 'PHASE 03',
    duration: '3 Months',
    title: 'Mock Test Series, Personal Monitoring & Performance Evaluation',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" className="h-8 w-8" aria-hidden="true">
        <rect x="13" y="8" width="22" height="32" rx="3" stroke="currentColor" strokeWidth="2.2" />
        <path d="M19 8.5v-1a5 5 0 0110 0v1" stroke="currentColor" strokeWidth="2.2" />
        <path d="M19 22h10M19 28h10M19 34h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M19 22l2.2 2.2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

function SectionBanner({ title, pill }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:mb-10 sm:flex-row sm:items-center sm:gap-5">
      <div className="relative inline-flex w-fit items-center overflow-hidden rounded-r-[2rem] rounded-l-xl bg-gradient-to-r from-brand-dark via-brand-primary to-[#3B82F6] px-6 py-3 shadow-[0_12px_30px_-12px_rgba(15,85,222,0.7)] sm:px-8 sm:py-3.5">
        <span className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-white/20 to-transparent" />
        <span className="pointer-events-none absolute -left-2 top-1/2 h-8 w-8 -translate-y-1/2 rounded-full bg-white/10 blur-md" />
        <h2 className="relative text-[13px] font-bold uppercase tracking-[0.14em] text-brand-white sm:text-body-sm md:text-[16px]">
          {title}
        </h2>
      </div>

      <span className="inline-flex w-fit items-center gap-2 rounded-full border-2 border-brand-primary/60 bg-brand-white px-4 py-2 text-label font-semibold text-brand-primary shadow-sm shadow-brand-primary/10 sm:px-5">
        <span className="h-2 w-2 rounded-full bg-brand-primary" />
        {pill}
      </span>
    </div>
  );
}

function PriceTag({ oldPrice, price, mutedClassName = 'text-brand-white/70' }) {
  return (
    <>
      {oldPrice ? (
        <span className={`text-[12px] font-semibold line-through ${mutedClassName}`}>
          {oldPrice}
        </span>
      ) : null}
      <span>{price}</span>
    </>
  );
}

function LaunchpadCard({ name, description, oldPrice, price, iconSrc }) {
  return (
    <article className="group flex h-full flex-col rounded-2xl border border-[#D7E3F8] bg-brand-white p-6 text-center shadow-[0_14px_40px_-22px_rgba(15,85,222,0.35)] transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-primary/40 hover:shadow-[0_22px_50px_-24px_rgba(15,85,222,0.45)]">
      <div className="mx-auto mb-5 h-28 w-28 transition-transform duration-300 group-hover:scale-105">
        <img src={iconSrc} alt="" className="h-full w-full object-contain" aria-hidden="true" />
      </div>
      <h3 className="mb-3 text-[17px] font-bold leading-snug text-brand-primary">{name}</h3>
      <div className="mx-auto mb-4 h-0.5 w-10 rounded-full bg-brand-primary" />
      <p className="mb-6 flex-1 text-label leading-relaxed text-brand-secondary">{description}</p>
      <span className="mx-auto inline-flex items-center gap-2 rounded-full bg-brand-primary px-6 py-2.5 text-body-sm font-bold text-brand-white shadow-md shadow-brand-primary/25">
        <PriceTag oldPrice={oldPrice} price={price} />
      </span>
    </article>
  );
}

function FlagshipCard({ name, description, oldPrice, price, visual }) {
  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-[#D7E3F8] bg-brand-white p-5 shadow-[0_14px_40px_-22px_rgba(15,85,222,0.35)] transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-primary/40 hover:shadow-[0_22px_50px_-24px_rgba(15,85,222,0.45)] sm:p-6">
      <span className="absolute left-0 top-0 z-10 rounded-br-xl bg-brand-primary px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-brand-white shadow-md">
        Flagship
      </span>

      <div className="mt-6 flex flex-1 flex-col gap-5 sm:flex-row sm:items-center">
        <div className="flex h-36 w-full items-center justify-center rounded-2xl bg-gradient-to-br from-[#E8F1FF] via-[#F5F9FF] to-brand-white p-3 sm:h-40 sm:w-44 sm:shrink-0">
          <img src={visual} alt="" className="h-full w-full object-contain" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1 text-center sm:text-left">
          <h3 className="mb-3 text-[18px] font-bold leading-snug text-brand-primary sm:text-card-title">
            {name}
          </h3>
          <div className="mx-auto mb-3 h-0.5 w-10 rounded-full bg-brand-primary sm:mx-0" />
          <p className="text-body-sm leading-relaxed text-brand-secondary">{description}</p>
        </div>
      </div>

      <div className="mt-5 border-t border-brand-border/70 pt-4">
        <div className="mb-5 grid gap-3 sm:grid-cols-2 sm:gap-4">
          <div className="flex items-center gap-2.5">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-background">
              <img
                src="/images/programs/college.png"
                alt=""
                className="h-10 w-10 object-contain"
                aria-hidden="true"
              />
            </span>
            <p className="text-left text-label-sm font-medium leading-snug text-brand-secondary">
              Exclusively for Partner Colleges
            </p>
          </div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-background">
              <img
                src="/images/programs/people.png"
                alt=""
                className="h-10 w-10 object-contain"
                aria-hidden="true"
              />
            </span>
            <p className="text-left text-label-sm font-medium leading-snug text-brand-secondary">
              Minimum Cohort 61 Students
            </p>
          </div>
        </div>

        <div className="flex justify-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-primary px-8 py-2.5 text-body-sm font-bold text-brand-white shadow-md shadow-brand-primary/25">
            <PriceTag oldPrice={oldPrice} price={price} />
          </span>
        </div>
      </div>
    </article>
  );
}

function ProgramsPage() {
  return (
    <div className="min-h-screen bg-[#F7FAFF] font-sans">
      <Header />

      <section className="page-banner">
        <img
          src="/images/programs-banner.png"
          alt="Industry-ready learning workspace"
          className="absolute inset-0 h-full w-full object-cover object-right"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-brand-white via-brand-white/92 to-transparent sm:from-brand-white/95 sm:via-brand-white/75 sm:to-transparent lg:from-brand-white/85 lg:via-brand-white/40 lg:to-transparent" />

        <div className="page-shell relative z-10 flex min-h-[inherit] items-center py-12">
          <div className="max-w-xl">
            <p className="mb-3 text-label font-semibold uppercase tracking-[0.2em] text-brand-primary">
              Our Programs
            </p>
            <h1 className="text-[34px] font-bold leading-[1.08] tracking-tight text-brand-navy sm:text-[44px] lg:text-[52px]">
              Industry-Ready Programs
              <br />
              Designed for Your Future
            </h1>
            <p className="mt-5 max-w-md text-body-sm leading-relaxed text-brand-secondary sm:text-body">
              Learn from experts, build real-world skills and become an industry leader.
            </p>
          </div>
        </div>
      </section>

      <main className="relative overflow-hidden pb-0 pt-10 lg:pt-14">
        <div className="pointer-events-none absolute -right-24 -top-10 h-80 w-80 rounded-full bg-brand-primary/15 blur-3xl" />
        <div className="pointer-events-none absolute -left-20 top-52 h-72 w-72 rounded-full bg-[#7EB6FF]/20 blur-3xl" />

        <div className="relative mx-auto max-w-[1440px] px-6 lg:px-10">
          <section className="mb-14 lg:mb-20">
            <SectionBanner
              title="Career Launchpad Series"
              pill="6-Month Professional Programs"
            />
            <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
              {launchpadPrograms.map((program) => (
                <LaunchpadCard key={program.name} {...program} />
              ))}
            </div>
          </section>

          <section className="mb-10 lg:mb-14">
            <SectionBanner title="Flagship Series" pill="10-Month Programs" />
            <div className="grid gap-6 lg:grid-cols-2">
              {flagshipPrograms.map((program) => (
                <FlagshipCard key={program.name} {...program} />
              ))}
            </div>
            <p className="mt-5 text-label-sm italic text-brand-secondary">
              *Flagship Series programs are launched exclusively for partner colleges with a minimum cohort of 61 students.
            </p>
          </section>

          <section className="mb-14 lg:mb-16">
            <SectionBanner
              title="Super 51 – MBA Career Accelerator"
              pill="Limited to 51 Students"
            />
            <div className="overflow-hidden rounded-3xl border border-[#D4AF37]/55 bg-[#070B16] p-5 text-brand-white shadow-[0_28px_70px_-30px_rgba(11,18,32,0.85)] sm:p-7 lg:p-8">
              <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:gap-8">
                <img
                  src="/images/programs/super51-badge.png"
                  alt="Super 51"
                  className="mx-auto h-36 w-36 shrink-0 object-contain sm:h-40 sm:w-40 lg:mx-0 lg:h-44 lg:w-44"
                />

                <div className="min-w-0 flex-1">
                  <div className="mb-6 flex flex-col items-center gap-4 text-center sm:flex-row sm:items-start sm:justify-between sm:text-left">
                    <p className="text-body-sm italic text-brand-white">
                      Only 51 Students. One Extraordinary Journey.
                    </p>
                    <span className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-[#D4AF37] px-5 py-2 text-body-sm font-bold text-[#0B0F1A] shadow-md shadow-[#D4AF37]/25">
                      <PriceTag oldPrice="₹ 45,000" price="₹ 40,000" mutedClassName="text-[#0B0F1A]/55" />
                    </span>
                  </div>

                  <div className="grid gap-5 md:grid-cols-[1fr_auto_1fr_auto_1fr] md:items-stretch md:gap-3 lg:gap-4">
                    {super51Phases.map((phase, index) => (
                      <div key={phase.phase} className="contents">
                        <div className="relative rounded-xl border border-[#D4AF37] px-4 pb-5 pt-7 text-center">
                          <span className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#D4AF37] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-[#0B0F1A]">
                            {phase.phase}
                          </span>
                          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full border border-[#D4AF37] text-[#D4AF37]">
                            {phase.icon}
                          </div>
                          <p className="mb-1 text-[17px] font-bold text-brand-white">{phase.duration}</p>
                          <p className="text-[13px] leading-relaxed text-brand-white/90">{phase.title}</p>
                        </div>
                        {index < super51Phases.length - 1 ? (
                          <div className="flex items-center justify-center text-[#D4AF37] md:px-1" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="currentColor" className="hidden h-5 w-5 md:block">
                              <path d="M8 5l8 7-8 7V5z" />
                            </svg>
                            <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5 md:hidden">
                              <path d="M5 8l7 8 7-8H5z" />
                            </svg>
                          </div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <p className="mt-5 text-center text-[12px] font-semibold uppercase tracking-[0.18em] text-brand-primary sm:text-label">
              Limited Cohorts, Exclusive Learning, Extraordinary Careers
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ProgramsPage;
